import { logger } from "../utils/logger";
const isBrowser = typeof window !== 'undefined'

export const localStorageClient = {
  /**
   * 値を取得
   * @param {string} key
   * @returns {any | null}
   */
  get(key) {
    if (!isBrowser) return null

    try {
      const value = window.localStorage.getItem(key)
      return value ? JSON.parse(value) : null
    } catch (error) {
      logger.error(`localStorage get error [${key}]`, error)
      return null
    }
  },

  /**
   * 値を保存
   * @param {string} key
   * @param {any} value
   */
  set(key, value) {
    if (!isBrowser) return

    try {
      window.localStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
      logger.error(`localStorage set error [${key}]`, error)
    }
  },

  /**
   * 値を削除
   * @param {string} key
   */
  remove(key) {
    if (!isBrowser) return

    try {
      window.localStorage.removeItem(key)
    } catch (error) {
      logger.error(`localStorage remove error [${key}]`, error)
    }
  },

  /**
   * 全削除
   */
  clear() {
    if (!isBrowser) return
    window.localStorage.clear()
  },
}
